import { FunctionComponent } from 'react'
import styled from 'styled-components'

interface IPhotoBackingContainerProps {
  cursor?: string
  borderRadius?: number
  topRadius?: number
  height?: number
  overlayText?: string
}

const PhotoBackingContainer = styled.div<IPhotoBackingContainerProps>`
  display: flex;
  position: relative;
  flex-basis: ${props => (props.overlayText ? 100 : 50)}%;
  width: 100%;
  ${props => props.height && `height: ${props.height}px; max-height: ${props.height}px;`}
  background: ${props => props.theme.colors.grey18};
  user-select: none;
  ${props => props.cursor && `cursor: ${props.cursor};`}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px;`}
  ${props =>
    props.topRadius
    && `
    border-top-left-radius: ${props.topRadius}px;
    border-top-right-radius: ${props.topRadius}px;
  `}
  /* keeps aspect ratio fixed as container width changes */
  ::before {
    content: '';
    display: inline-block;
    height: 0;
    padding-bottom: ${props => props.theme.metrics.photoRatio}%;
  }
`

interface IPhotoProps {
  topRadius?: number
}
const Photo = styled.img<IPhotoProps & IPhotoBackingContainerProps>`
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  ${props => props.topRadius && `border-top-left-radius: ${props.topRadius}px;`}
  ${props => props.topRadius && `border-top-right-radius: ${props.topRadius}px;`}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius}px;`}
`

interface IOverlayGradientProps {
  topRadius?: number
}
const OverlayGradient = styled.div<IOverlayGradientProps>`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15));
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  ${props => props.topRadius && `border-top-left-radius: ${props.topRadius}px;`}
  ${props => props.topRadius && `border-top-right-radius: ${props.topRadius}px;`}
  z-index: 2;
`

const Banner = styled.div`
  position: absolute;
  text-align: center;
  font-weight: 800;
  font-size: 48px;
  color: ${props => props.theme.colors.white};
  z-index: 10;
`

interface IProps {
  alt?: string
  cursor?: string
  src: string
  borderRadius?: number
  topRadius?: number
  height?: number
  overlayText?: string
}

/* A div with background image that will maintain its aspect ratio as the viewport
 * width changes
 */
const GridImage: FunctionComponent<IProps> = ({
  alt,
  borderRadius,
  cursor,
  children,
  src,
  topRadius,
  height,
  overlayText,
}) => (
  <>
    {overlayText && <Banner>{overlayText}</Banner>}
    <PhotoBackingContainer
      cursor={cursor}
      borderRadius={borderRadius}
      topRadius={topRadius}
      height={height}
      overlayText={overlayText}
    >
      <Photo
        src={src}
        topRadius={topRadius}
        alt={alt}
        loading="lazy"
        borderRadius={borderRadius}
      />
      {overlayText && <OverlayGradient topRadius={topRadius} />}
      {children}
    </PhotoBackingContainer>
  </>
)

export default GridImage
